import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { createOrder, getOrders } from '../../api/ans';
import resetStore from '../resetStore';

const initialState = {
  ordersList: [],
  status: null,
  error: null,
  selectOpen: false,
  selectAddres: { ref: 0 },
  addresList: [],
  currentTabOrders: 'active',
};

export const updateOrderThunk = createAsyncThunk(
  'orders/updateOrder',
  async (payload, { rejectWithValue }) => {
    try {
      console.log(payload, 'updateOrderThunk from');
      const response = await createOrder(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Ошибка обновления заказа');
    }
  }
);

export const createOrderThunk = createAsyncThunk(
  'orders/createOrder',
  async (asnData, { rejectWithValue }) => {
    try {
      const result = await createOrder(asnData);
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка создания ASN'
      );
    }
  }
);

export const getOrdersThunk = createAsyncThunk(
  'orders/getOrders',
  async (asnData, { rejectWithValue }) => {
    try {
      const result = await getOrders();
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка создания ASN'
      );
    }
  }
);

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders(state, action) {
      state.ordersList = action.payload;
    },
    openSelectAddres(state, action) {
      state.selectOpen = action.payload;
      console.log(action.payload);
    },
    setSelectAddres(state, action) {
      state.selectAddres = action.payload;
    },
    setAddresList(state, action) {
      state.addresList = action.payload;
    },
    setCurrentTabOrders(state, action) {
      state.currentTabOrders = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOrderThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateOrderThunk.fulfilled, (state) => {
        state.status = 'resolved';

        // const updatedOrder = action.payload;
        // const index = state.ordersList.findIndex(
        //   (o) => o.order_no === updatedOrder.order_no
        // );
        // if (index !== -1) {
        //   state.ordersList[index] = updatedOrder;
        // }
      })
      .addCase(updateOrderThunk.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(createOrderThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createOrderThunk.fulfilled, (state, action) => {
        state.status = 'resolved';
        state.ordersList.push(action.payload); // добавляем новый заказ
      })
      .addCase(createOrderThunk.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(getOrdersThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getOrdersThunk.fulfilled, (state, action) => {
        state.status = 'resolved';
        state.ordersList = action.payload.orders; // добавляем список заказов
      })
      .addCase(getOrdersThunk.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(resetStore, () => initialState);
  },
});

export const {
  setOrders,
  openSelectAddres,
  setSelectAddres,
  setAddresList,
  setCurrentTabOrders,
} = ordersSlice.actions;
export default ordersSlice.reducer;
